// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".VqZnlFG1RN1068a2C85DrA\\=\\={display:flex}.WtU\\+zhbMKqGih8pcyGBaYQ\\=\\={height:auto}", "",{"version":3,"sources":["webpack://./src/pages/DeliveryDashboard/components/DashboardCourierList/DashboardCourierList.module.scss"],"names":[],"mappings":"AAAA,4BACI,YAAA,CAGJ,6BACI,WAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboardCourierList": "VqZnlFG1RN1068a2C85DrA==",
	"dashboardCourierList_items": "WtU+zhbMKqGih8pcyGBaYQ=="
};
export default ___CSS_LOADER_EXPORT___;
